/*
 * @Auther: 罗耀祖
 * @Date: 2022-02-09 16:12:57
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-04-16 13:52:08
 * @name: 我的售后列表页面对象
 * @Description: 我的售后列表页面对象
 * @FilePath: \project\src\views\index\afterSale\afterSaleList\afterSaleList.view.js
 * @Author: desktop
 */
import { confirmation, debounceation } from "@/utils/decorator";
import issueService from "@/module/issue/issue.service";
const afterSaleListView = class {
  constructor() {
    this.issueService = new issueService();
    // 搜索条件
    this.searchForm = {
      piano_no: '',
      piano_model: '',
      agency_name: '',
      question: '',
      type: 'all',
      musical: '',
      issue_name: '',
      date: [],
    };
    // 分页信息
    this.pagination = {
      page: 1,
      limit: 10,
    };
    this.typeList = [
      //状态数组
      {
        value: "all",
        text: "全部",
      },
      {
        value: "check",
        text: "待审批",
      },
      {
        value: "ensure",
        text: "待确认",
      },
      {
        value: "todo",
        text: "待处理",
      },
      {
        value: "finish",
        text: "已处理",
      },
      {
        value: "fail",
        text: "失败",
      },
    ];
    this.musicals = [
      // 乐器类别数组
      {
        value: "",
        text: "全部",
      },
      {
        value: "三角琴",
        text: "三角琴",
      },
      {
        value: "电钢琴",
        text: "电钢琴",
      },
      {
        value: "立式琴",
        text: "立式琴",
      },
      {
        value: "其他",
        text: "其他",
      },
    ];
    this.issue_names = [
      // 问题类型数组
      {
        value: "",
        text: "全部",
      },
      {
        value: "问题反馈",
        text: "问题反馈",
      },
      {
        value: "部件更换",
        text: "部件更换",
      },
      {
        value: "整琴退换",
        text: "整琴退换",
      },
      {
        value: "货损",
        text: "货损",
      },
    ];
    this.tableLoading = false;
    this.tableTotal = 0;
    this.tableData = [];
    this.allow_print = 0; //允许打印 1 允许 0 不允许
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 查询
   */
  @debounceation(300)
  onQuery() {
    this.initPagination();
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 刷新
   */
  @debounceation(300)
  initData() {
    this.initSearchForm(); //初始化搜索条件表单
    this.initPagination(); //初始化分页信息
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 初始化搜索条件表单
   */
  initSearchForm() {
    this.searchForm = {
      piano_no: '',
      piano_model: '',
      agency_name: '',
      question: '',
      type: 'all',
      musical: '',
      issue_name: '',
      date: [],
    };
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 初始化分页信息
   */
  initPagination() {
    this.pagination = {
      page: 1,
      limit: 10,
    };
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 获取表格数据
   */
  getTableData() {
    let {
      piano_no,
      piano_model,
      agency_name,
      question,
      type,
      musical,
      issue_name,
    } = this.searchForm ?? {};
    let start_time = this.searchForm?.date?.[0] ?? '';
    let end_time = this.searchForm?.date?.[1] ?? '';
    start_time && (start_time = (
      new Date((start_time + " 00:00:00").replace(/-/g, "/")).getTime() / 1000
    ).toFixed(0));
    end_time && (end_time = (
      new Date((end_time + " 23:59:59").replace(/-/g, "/")).getTime() / 1000
    ).toFixed(0));
    let pagination = this.pagination ?? {};
    let req = {
      piano_no,
      piano_model,
      agency_name,
      question,
      type,
      musical,
      issue_name,
      start_time,
      end_time,
      ...pagination,
    }
    this.tableLoading = true;
    this.issueService.issueGetList(req).then(res => {
      this.allow_print = res.data.allow_print;
      this.tableTotal = res.data.total;
      this.tableData = res.data.data.map(x => {
        x.piano_model = x.piano_model || '/';
        x.piano_no = x.piano_no || '/';
        x.issue_name = x.musical === '其它' ? x.musical : x.issue_name;
        x.positions = x.positions || '/';
        x.questions = x.questions || '/';
        x.statuText = this.issueService.getStatusText(x);
        return x;
      });
    }).finally(() => {
      this.tableLoading = false;
    })
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 跳转详情
   * @param {Object} row 行数据
   */
  @debounceation(300)
  toDetail(row) {
    this.issueService.pushToDetail('/index/afterSale', row);
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 废单
   * @param {Object} row 行数据
   */
  @confirmation('确认废单?')
  destory(row) {
    this.issueService.endFlow({
      issue_id: row.id,
      run_process_id: row.run_process_id,
      check_con: '',
    }).then(res => {
      this.getTableData();
    })
  }
}

export default afterSaleListView;